/* tslint:disable */
/* eslint-disable */
/**
 * CarePlatform User Preferences API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserLocaleType,
    UserLocaleTypeFromJSON,
    UserLocaleTypeFromJSONTyped,
    UserLocaleTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateUserLocaleRequest
 */
export interface UpdateUserLocaleRequest {
    /**
     * 
     * @type {UserLocaleType}
     * @memberof UpdateUserLocaleRequest
     */
    locale: UserLocaleType;
}

export function UpdateUserLocaleRequestFromJSON(json: any): UpdateUserLocaleRequest {
    return UpdateUserLocaleRequestFromJSONTyped(json, false);
}

export function UpdateUserLocaleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserLocaleRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'locale': UserLocaleTypeFromJSON(json['locale']),
    };
}

export function UpdateUserLocaleRequestToJSON(value?: UpdateUserLocaleRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'locale': UserLocaleTypeToJSON(value.locale),
    };
}


